import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/**
 * Kakao SDK는 GlobalScript에서 로드 및 초기화됨
 * 이 훅은 SDK가 준비되었는지만 확인하고 공유 기능을 제공
 */
export const useKakaoShare = () => {
  const $ = _c(7);
  const [isInitialized, setIsInitialized] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      let cancelled = false;
      let timerId;
      const checkKakaoReady = () => {
        if (cancelled) {
          return;
        }
        if (window.Kakao?.isInitialized?.()) {
          setIsInitialized(true);
        } else {
          timerId = setTimeout(checkKakaoReady, 100);
        }
      };
      checkKakaoReady();
      return () => {
        cancelled = true;
        if (timerId) {
          clearTimeout(timerId);
        }
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isInitialized) {
    t2 = (shareUrl, title, description, imageUrl, t3) => {
      const buttonTitle = t3 === undefined ? "\uC790\uC138\uD788 \uBCF4\uAE30" : t3;
      if (!isInitialized) {
        console.error("Kakao SDK\uAC00 \uCD08\uAE30\uD654\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.");
        return;
      }
      window.Kakao?.Share?.sendDefault?.({
        objectType: "feed",
        content: {
          title,
          description,
          imageUrl,
          link: {
            mobileWebUrl: shareUrl,
            webUrl: shareUrl
          }
        },
        buttons: [{
          title: buttonTitle,
          link: {
            mobileWebUrl: shareUrl,
            webUrl: shareUrl
          }
        }]
      });
    };
    $[2] = isInitialized;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const shareToKakao = t2;
  let t3;
  if ($[4] !== isInitialized || $[5] !== shareToKakao) {
    t3 = {
      shareToKakao,
      isInitialized
    };
    $[4] = isInitialized;
    $[5] = shareToKakao;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};